var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full flex justify-center mt-2"},[_c('img',{staticClass:"w-10",attrs:{"data-src":require('@/assets/images/SpaceCodeGreenLogo.png'),"alt":"space_code_logo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }